// extracted by mini-css-extract-plugin
export default {"Drawer":"wWmmS62G","ContentRoot":"npOs5O_n","header":"kt0ESQcJ","footer":"vN9G53zO","content":"oepAWo1P"};